import { FlattenedPage } from "@types-runway/questionnaire";

import {
  ProgressSection,
  progressSectionNames,
  progressSections,
  sectionOfPage,
} from "./progressSections";

export interface SectionSegment {
  section: ProgressSection;
  name: string;
  fillRatio: number;
  isCurrent: boolean;
}

const fillRatioOf = (
  section: ProgressSection,
  askedScreens: FlattenedPage[],
  currentIndex: number
): number => {
  const minimumFillRatio = 0.01;
  const sectionIndexes = askedScreens
    .map((page, index) => (sectionOfPage(page) === section ? index : -1))
    .filter((index) => index >= 0);
  const screensBeforeCurrent = sectionIndexes.filter((index) => index < currentIndex).length;

  return Math.max(screensBeforeCurrent / sectionIndexes.length, minimumFillRatio);
};

export const deriveSectionSegments = (
  askedScreens: FlattenedPage[],
  currentStateKey: string
): SectionSegment[] => {
  const currentIndex = askedScreens.findIndex((page) => page.stateKey === currentStateKey);
  const currentSection = currentIndex < 0 ? null : sectionOfPage(askedScreens[currentIndex]);
  const currentSectionOrder = progressSections.findIndex((section) => section === currentSection);

  return progressSections.map((section, order) => {
    const isFinished = order < currentSectionOrder;
    const isCurrent = order === currentSectionOrder;
    const fillRatio = isCurrent
      ? fillRatioOf(section, askedScreens, currentIndex)
      : Number(isFinished);

    return { section, name: progressSectionNames[section], fillRatio, isCurrent };
  });
};
